import { render, staticRenderFns } from "./payrollUserSalaryRecord.vue?vue&type=template&id=8555caba&"
import script from "./payrollUserSalaryRecord.vue?vue&type=script&lang=js&"
export * from "./payrollUserSalaryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports